<div id="wrap">
   <div *ngIf="!newEdition">
      <h1 class="fontSize32 lineHeight34" id="all_title">领袋</h1>
      <h2 class="fontSize16 line" id="all_subtitle">POCKET LEADERSHIP</h2>

      <p class="fontSize16 lineHeight24" id="text_1">曾几何时企业培训迎来了这样的“新常态”：</p>

      <div id="text_box_1">
         <p class="fontSize14 lineHeight24">员工最关心WIFI密码是多少、充电头在哪。</p>
         <p class="fontSize14 lineHeight24">讲师在上面授课，下面在朋友圈狂刷。</p>
         <p class="fontSize14 lineHeight24">对来时讲课内容无感，培训效果不好。</p>
         <p class="fontSize14 lineHeight24">......</p>
         <div id="text_box_1_arrow"></div>
      </div>


      <div id="text_box_2">
         <p class="fontSize16 lineHeight24">
            大量的研究和实践表明：数字时代，越来越多的员工更加关注于<span>自我实现的心理需求是否得到满足</span>。如何在确保培训效果的同时，让学习变得更加便捷精准，早已成为这个时代企业培训面临的全新挑战。
         </p>
      </div>

      <div id="subtitle_1">
         <div id="subtitle_1_left" class="fontSize21">
            DDI
         </div>
         <div id="subtitle_1_right" class="fontSize16">
            首发领导力在线教育产品——领袋！
         </div>
      </div>

      <div id="text_box_3" class="fontSize18 lineHeight27">
         基于行为心理学的体系知识及教学设计，结合AI等前沿数字化技术，构建能力诊断、精准推送、虚拟演练和顾问点评等各类学习环节，为学员提供按需学习、沉浸体验，即学即用的转型之旅。并通过可视化的管理模式，帮助企业解决大规模员工发展问题，有效降低企业培训成本。
      </div>

      <div id="enterprise_value">
         <h3 id="enterprise_value_title" class="fontSize27">
            企业价值
            <div class="map_pic"></div>
         </h3>
         <div class="enterprise_value_item float_left">
            <div class="enterprise_value_item_pic" id="enterprise_value_item_pic_1">

            </div>
            <div class="enterprise_value_item_text_white fontSize18">
               激发学员动力<br/>
               提升学员满意度
            </div>
            <div class="enterprise_value_item_text_grey fontSize14">
               完全个性化的教学方案
            </div>
         </div>

         <div class="enterprise_value_item float_right">
            <div class="enterprise_value_item_pic" id="enterprise_value_item_pic_2">

            </div>
            <div class="enterprise_value_item_text_white fontSize18">
               学习效果可衡量<br/>
               解决实际业务问题
            </div>
            <div class="enterprise_value_item_text_grey fontSize14">
               测量与发展的无缝集成
            </div>
         </div>

         <div class="enterprise_value_item float_left">
            <div class="enterprise_value_item_pic" id="enterprise_value_item_pic_3">

            </div>
            <div class="enterprise_value_item_text_white fontSize18">
               降低培训成本<br/>
               共享专业资源
            </div>
            <div class="enterprise_value_item_text_grey fontSize14">
               跨越时空间的服务交付
            </div>
         </div>

         <div class="enterprise_value_item float_right">
            <div class="enterprise_value_item_pic" id="enterprise_value_item_pic_4">

            </div>
            <div class="enterprise_value_item_text_white fontSize18">
               极简管理流程<br/>
               发展洞察全掌握
            </div>
            <div class="enterprise_value_item_text_grey fontSize14">
               学以致用真实案例输出
            </div>
         </div>
      </div>

      <div id="product_features">
         <h3 id="product_features_title" class="fontSize27">
            产品特色
            <div class="map_pic"></div>
         </h3>
         <div class="product_features_item" id="product_features_item_1">
            <div class="product_features_item_title fontSize21">
               管理者自我认知
            </div>
            <div class="product_features_item_text fontSize16 lineHeight24">
               基于五大人格理论及实际业务场景，实现个性&行为双向比对，有效帮助管理者自我洞察，让学习更有动力。
            </div>
            <div id="product_features_item_1_pic"></div>
         </div>
         <div class="product_features_item">
            <div class="product_features_item_title fontSize21">
               权威课程体系
            </div>
            <div class="product_features_item_text fontSize16 lineHeight24">
               DDI结合48年人才发展领域专业沉淀，以国内人才发展体系为基础，打造新经理人晋升必备7大关键能力体系课程，为新经理人的成长提供清晰地发展路线图。
            </div>
            <div id="product_features_item_2_card_1" class="product_features_item_2_card">
               <div id="product_features_item_2_card_1_left" class="product_features_item_2_card_teacher">
                  <div class="product_features_item_2_card_pic" id="product_features_item_2_card_1_left_pic"></div>
                  <div class="fontSize21 product_features_item_2_card_name">
                     Mindy
                  </div>
                  <div class="fontSize14 product_features_item_2_card_professional_title">
                     DDI全球副总裁
                  </div>
               </div>
               <div id="product_features_item_2_card_1_right" class="fontSize16 lineHeight24">
                  讲师介绍讲师介绍讲师介绍讲师介绍讲师介绍讲师介绍讲师介绍讲师介绍讲师介绍
               </div>
            </div>

            <div id="product_features_item_2_card_2"  class="product_features_item_2_card">
               <div id="product_features_item_2_card_2_left" class="fontSize16 lineHeight24">
                  讲师介绍讲师介绍讲师介绍讲师介绍讲师介绍讲师介绍讲师介绍讲师介绍讲师介绍
               </div>
               <div id="product_features_item_2_card_2_right" class="product_features_item_2_card_teacher">
                  <div class="product_features_item_2_card_pic" id="product_features_item_2_card_2_right_pic"></div>
                  <div class="fontSize21 product_features_item_2_card_name">
                     Alex
                  </div>
                  <div class="fontSize14 product_features_item_2_card_professional_title">
                     讲师title
                  </div>
               </div>
            </div>
         </div>
         <div class="product_features_item">
            <div class="product_features_item_title fontSize21">
               专业教学设计
            </div>
            <div class="product_features_item_text fontSize16 lineHeight24">
               混合学习设计，搭建全面系统的能力提升方案，帮助企业达成O2O最佳实践。
            </div>
            <div id="product_features_item_3_pic"></div>
         </div>
         <div class="product_features_item">
            <div class="product_features_item_title fontSize21">
               企业可视化管理
            </div>
            <div class="product_features_item_text fontSize16 lineHeight24">
               全员学习数据多维度呈现，总结团队成员的行为风格曲线图，直观，客观地监督培训效果！
            </div>
            <div id="product_features_item_4_pic"></div>
         </div>
      </div>

      <div id="product_display">
         <h3 id="product_display_title" class="fontSize27">
            产品展示
            <div class="map_pic"></div>
         </h3>
         <div id="product_display_pic"></div>
      </div>

      <div id="target_trainee">
         <h3 id="target_trainee_title" class="fontSize27">
            <span id="target_trainee_title_top">目标学员&</span><br/>
            <span id="target_trainee_title_bottom">个人价值</span>
            <div class="map_pic" id="target_trainee_map_pic"></div>
         </h3>
         <div id="target_trainee_item_wrap">
            <div class="target_trainee_item">
               <div id="target_trainee_item_1_pic"></div>
               <div class="target_trainee_item_text fontSize16 lineHeight21">
                  企业基层<br/>
                  管理者
               </div>
            </div>
            <div class="target_trainee_item">
               <div id="target_trainee_item_2_pic"></div>
               <div class="target_trainee_item_text fontSize16 lineHeight21">
                  高潜人才
               </div>
            </div>
            <div class="target_trainee_item">
               <div id="target_trainee_item_3_pic"></div>
               <div class="target_trainee_item_text fontSize16 lineHeight21">
                  储备人才
               </div>
            </div>
         </div>
         <div id="target_trainee_text" class="fontSize16 lineHeight24">
            学习收益：系统提升学习者的管理知识和技能、培养具备综合视野的优秀领导者、精准满足学习者自我实现的心理需求。
         </div>
      </div>
   </div>


  <div *ngIf="newEdition">
    <img src="../../assets/picture/activity/wechatIntrodution.png" alt=""  class="newIntroduction">
  </div>

   <!--<div *ngIf="newEdition">-->

      <!--<div id="new_text_box_2">-->
         <!--<p class="fontSize16 lineHeight24">企业新经理们上任，</p>-->
         <!--<p class="fontSize16 lineHeight24">怎样才能培训他们与新角色同步成长？<br/><br/></p>-->
         <!--<p class="fontSize16 lineHeight24">各部门众口难调，</p>-->
         <!--<p class="fontSize16 lineHeight24">如何才能满足更精细的人才发展要求？<br/><br/></p>-->
         <!--<p class="fontSize16 lineHeight24">组织一次跨区域培训，费时费力，</p>-->
         <!--<p class="fontSize16 lineHeight24">怎样才能更高效便捷？<br/><br/></p>-->
         <!--<p class="fontSize16 lineHeight24">一线管理工作繁多，</p>-->
         <!--<p class="fontSize16 lineHeight24">什么样的培训才能抓住新经理们的心？<br/><br/></p>-->
         <!--<p class="fontSize16 lineHeight24">辛苦筹备培训发展，效果难以直观展现，</p>-->
         <!--<p class="fontSize16 lineHeight24">数字化技术能否为我所用？</p>-->
      <!--</div>-->

      <!--<div id="new_text_box_3">-->
         <!--<p class="fontSize18 lineHeight27">应对难题，“<span class="colorWord fontSize21"> 英跃 </span>”来了</p>-->
         <!--<p class="fontSize18 lineHeight27">传承DDI经典，专注数字化发展</p>-->
         <!--<p class="fontSize18 lineHeight27">敬呈全新领导力人才跃迁方案</p>-->
      <!--</div>-->

      <!--<div id="new_picture_content_1"></div>-->

      <!--<div id="new_text_box_4">-->
         <!--<p class="fontSize18 lineHeight27">48年企业人才发展专业领域沉淀</p>-->
      <!--</div>-->

      <!--<div id="new_picture_content_2"></div>-->

      <!--<div id="new_text_box_5">-->
         <!--<p class="fontSize18 lineHeight27">进阶式领导力发展路径</p>-->
         <!--<p class="fontSize14 lineHeight24 marginTop03">围绕团队管理真实业务场景，</p>-->
         <!--<p class="fontSize14 lineHeight24">提出针对性发展建议，</p>-->
         <!--<p class="fontSize14 lineHeight24">帮助一线管理者快速掌握“7+1”关键能力。</p>-->
      <!--</div>-->

      <!--<div id="new_picture_content_3"></div>-->

      <!--<div id="new_text_box_6">-->
         <!--<p class="fontSize18 lineHeight27">“一站式”体系化方案</p>-->
         <!--<p class="fontSize14 lineHeight24 marginTop03">组织心理学、教育心理学和数字技术三大领域的融合，</p>-->
         <!--<p class="fontSize14 lineHeight24">学习、练习、测评，一站轻松解决。</p>-->
         <!--<p class="fontSize14 lineHeight24">同一套能力体系贯穿始终，</p>-->
         <!--<p class="fontSize14 lineHeight24">效果评估很科学，培训挑战不再难。</p>-->
      <!--</div>-->

      <!--<div id="new_picture_content_4"></div>-->

      <!--<div id="new_text_box_7">-->
         <!--<p class="fontSize18 lineHeight27">关键能力加速塑造</p>-->
         <!--<p class="fontSize18 lineHeight27">领导力学成可认证</p>-->
      <!--</div>-->

      <!--<div id="new_picture_content_5"></div>-->
   <!--</div>-->

   <img src="../../assets/picture/activity/title1x.png" alt="" id="logoPic">


   <div id="bottom_space"></div>
</div>




<!--<div id="bottom_space"></div>-->

<button id="choiceBtn" *ngIf="showButton" (click)="register()" [ngClass]="{'choiceBtn_disable':choiceBtnDisable,'choiceBtn_enable':!choiceBtnDisable}" class="fontSize16">
   {{choiceBtnText}}
</button>




// WEBPACK FOOTER //
// ./src/app/activity-introduction/activity-introduction.component.html